import { z } from "zod";

import { zNonEmptyString } from "../../common/util";

export const zOriginatingBrokerSchema = z.object({
  dtc_number: zNonEmptyString,
  name: zNonEmptyString,
});

export type OriginatingBrokerSchema = z.infer<typeof zOriginatingBrokerSchema>;
